import { Component, OnInit, Inject } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { ILookupBase } from 'src/app/Models/ILookupBase';
import { ReportService } from 'src/app/Services/ReportService';
import { Globals } from 'src/app/globals';
import { LookupService } from 'src/app/Services/LookupService';
import { saveAs } from 'node_modules/file-saver/src/FileSaver';
import { IReportParameter } from 'src/app/Models/IReportParameter';
import { IReportRequest } from 'src/app/Models/IReportRequest';
import { IReportCSV } from 'src/app/Models/IReportCSV';
import { IReportPDF } from 'src/app/Models/IReportPDF';
import { IReportRequestExcelBased } from 'src/app/Models/IReportRequestExcelBased';
import { ISqlParam } from 'src/app/Models/ISqlParam';

@Component({
  selector: 'app-_400_ExcelBasedReports',
  templateUrl: './_400_ExcelBasedReports.component.html',
  styleUrls: ['./_400_ExcelBasedReports.component.css']
})
export class _400_ExcelBasedReportsComponent implements OnInit {

  site: SelectItem[]; _siteId: string = "";
  siteIdList: ILookupBase[] = [
    { value: "JCS", label: "JCS", shortText: null, updatedOn: null },
    { value: "IPOLY", label: "IPOLY", shortText: null, updatedOn: null },
    { value: "LACHSA", label: "LACHSA", shortText: null, updatedOn: null }];
  _baseUrl: string;
  date: Date; fromDate: Date;//datepicker
  fileName: string;
  public showSpinner: boolean = false;
  _lookupService: LookupService;
  _reportService: ReportService;
  _myGlobals: Globals;

  constructor(lookupService: LookupService, reportService: ReportService, globals: Globals,
    @Inject('BASE_URL') baseUrl: string
  ) {
    this._lookupService = lookupService;
    this._reportService = reportService;
    this._baseUrl = baseUrl;
    this._myGlobals = globals;
  }

  ngOnInit() {
    let today = new Date();
    this.date = new Date(today.getMonth() + 1 + '/' + today.getDate() + '/' + today.getFullYear());
    this.fromDate = new Date('07/01' + '/' + ((today.getMonth() + 1) > 7 ? today.getFullYear() : today.getFullYear() - 1));
  }

  setSite(id): void {
    this._siteId = id.value;
  }

  disabilityCodeMismatch(): void {
    this.showSpinner = true;
    let reportRequest = {} as IReportRequestExcelBased;
    reportRequest.reportName = "DisabilityCodeMismatch";

    this._reportService.getCSVReport(reportRequest).subscribe((res: IReportCSV) => {
      var binaryString = window.atob(res.base64FileContent);
      var stringLength = binaryString.length;
      var bytes = new Uint8Array(stringLength);
      for (var i = 0; i < stringLength; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      this.showSpinner = false;
      saveAs(new Blob([bytes], { type: 'text/csv' }), res.fileName);
          },
            err => {
              this.showSpinner = false;
              console.error(err);
            }
    );
  }

  lastEvalDateisOverThreeYearsOld(): void {
    this.showSpinner = true;
    let reportRequest = {} as IReportRequestExcelBased;
    reportRequest.reportName = "LastEvalDateOverThreeYearsOld";

    this._reportService.getCSVReport(reportRequest).subscribe((res: IReportCSV) => {
      var binaryString = window.atob(res.base64FileContent);
      var stringLength = binaryString.length;
      var bytes = new Uint8Array(stringLength);
      for (var i = 0; i < stringLength; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      this.showSpinner = false;
      saveAs(new Blob([bytes], { type: 'text/csv' }), res.fileName);
    },
      err => {
        this.showSpinner = false;
        console.error(err);
      }
    );
  }

  pastDuePTA(): void {
    this.showSpinner = true;
    let reportRequest = {} as IReportRequestExcelBased;
    reportRequest.reportName = "PastDuePTA-IEP";

    this._reportService.getCSVReport(reportRequest).subscribe((res: IReportCSV) => {
      var binaryString = window.atob(res.base64FileContent);
      var stringLength = binaryString.length;
      var bytes = new Uint8Array(stringLength);
      for (var i = 0; i < stringLength; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      this.showSpinner = false;
      saveAs(new Blob([bytes], { type: 'text/csv' }), res.fileName);
    },
      err => {
        this.showSpinner = false;
        console.error(err);
      }
    );
  }

  missingChildFind(): void {
    this.showSpinner = true;
    let reportRequest = {} as IReportRequestExcelBased;
    reportRequest.reportName = "MissingChildFind";
    reportRequest.schoolName = this._siteId === "" ? "JCS" : this._siteId;   

    this._reportService.getCSVReport(reportRequest).subscribe((res: IReportCSV) => {
      var binaryString = window.atob(res.base64FileContent);
      var stringLength = binaryString.length;
      var bytes = new Uint8Array(stringLength);
      for (var i = 0; i < stringLength; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      this.showSpinner = false;
      saveAs(new Blob([bytes], { type: 'text/csv' }), res.fileName);
    },
      err => {
        this.showSpinner = false;
        console.error(err);
      }
    );
  }

  printSignatureIEPs(): void {
    this.showSpinner = true;
    let reportRequest = {} as IReportRequestExcelBased;
    reportRequest.reportName = "PrintSignatureIEPs";


    reportRequest.sqlParamArray = [ { parameterName: 'startDate', value: this.fromDate.toISOString() },
                                    { parameterName: 'endDate', value: this.date.toISOString() }]

    this._reportService.getCSVReport(reportRequest).subscribe((res: IReportCSV) => {
      var binaryString = window.atob(res.base64FileContent);
      var stringLength = binaryString.length;
      var bytes = new Uint8Array(stringLength);
      for (var i = 0; i < stringLength; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      this.showSpinner = false;
      saveAs(new Blob([bytes], { type: 'text/csv' }), res.fileName);
    },
      err => {
        this.showSpinner = false;
        console.error(err);
      }
    );
  }

  missingEPICStudentIdInAeries(): void {
    this.showSpinner = true;
    let reportRequest = {} as IReportRequestExcelBased;
    reportRequest.reportName = "MissingEPICStudentIdInAeries";

    this._reportService.getCSVReport(reportRequest).subscribe((res: IReportCSV) => {
      var binaryString = window.atob(res.base64FileContent);
      var stringLength = binaryString.length;
      var bytes = new Uint8Array(stringLength);
      for (var i = 0; i < stringLength; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      this.showSpinner = false;
      saveAs(new Blob([bytes], { type: 'text/csv' }), res.fileName);
    },
      err => {
        this.showSpinner = false;
        console.error(err);
      }
    );
  }

}
